export default {"src":"/_next/static/media/no-result.b574bcc9.svg","height":453,"width":600};